import { Expose } from 'class-transformer';
import type BasketBillingMethod from './BasketBillingMethod'

export default class Order {
  @Expose() billingmethod: (string | null) = null;
  @Expose() customerhandoffcharge: number = 0;
  @Expose() deliverymode: (string | null) = null;
  @Expose() usertype: (string | null) = null;
  @Expose() firstname: (string | null) = null;
  @Expose() lastname: (string | null) = null;
  @Expose() emailaddress: (string | null) = null;
  @Expose() contactnumber: (string | null) = null;
  @Expose() cardnumber: (string | null) = null;
  @Expose() expiryyear: (string | null) = null;
  @Expose() expirymonth: (string | null) = null;
  @Expose() cvv: (string | null) = null;
  @Expose() streetaddress: (string | null) = null;
  @Expose() streetaddress2: (string | null) = null;
  @Expose() city: (string | null) = null;
  @Expose() state: (string | null) = null;
  @Expose() zip: (string | null) = null;
  @Expose() table: (string | null) = null;
  @Expose() tip: number = 0;
  @Expose() country: (string | null) = null;
  @Expose() orderref: (string | null) = null;
  // @Expose() vehicle: CurbsideVehicle?;
  @Expose() billingaccounts: (BasketBillingMethod[] | null) = null;

  constructor(
    billingmethod: string, 
    customerhandoffcharge: number,
    deliverymode: string, 
    usertype: string, 
    firstname: string, 
    lastname: string, 
    emailaddress: string, 
    contactnumber: string, 
    cardnumber: string, 
    expiryyear: string, 
    expirymonth: string, 
    cvv: string, 
    streetaddress: string, 
    streetaddress2: string, 
    city: string, 
    state: string, 
    zip: string, 
    table: string, 
    tip: number,
    country: string, 
    orderref: string, 
    billingaccounts: BasketBillingMethod[], 
  ) {
    // this.authtoken = authtoken;
    this.billingmethod = billingmethod;
    this.customerhandoffcharge = customerhandoffcharge;
    this.deliverymode = deliverymode;
    this.usertype = usertype;
    this.firstname = firstname;
    this.lastname = lastname;
    this.emailaddress = emailaddress;
    this.contactnumber = contactnumber;
    this.cardnumber = cardnumber;
    this.expiryyear = expiryyear;
    this.expirymonth = expirymonth;
    this.cvv = cvv;
    this.streetaddress = streetaddress;
    this.streetaddress2 = streetaddress2;
    this.city = city;
    this.state = state;
    this.zip = zip;
    this.table = table;
    this.tip = tip;
    this.country = country;
    this.orderref = orderref;
    this.billingaccounts = billingaccounts;
  }

}